// Module
var code = `<div class="SearchView">
	<div>
		<form>
			{{#hideStores}}
			<input type="hidden" class="select-store" name="store">
			{{/hideStores}}
			{{#hideOutputs}}
				<input type="hidden" class="select-output" name="output">
			{{/hideOutputs}}
			<div class="w-100"><label>{{queryTitle}}</label>
				<div>
					<textarea name="query"></textarea>
				</div>
			</div>
			<div class="d-flex justify-content-between mt-2">
				{{^hideStores}}
				<div class="w-50 me-2">
					<label>Store</label>
					<select class="form-select select-store" name="store">
						{{#stores}}
						<option value="{{.}}">{{.}}</option>
						{{/stores}}
					</select>
				</div>
				{{/hideStores}}
				{{^hideOutputs}}
				<div class="w-50 me-2">
					<label>Output</label>
					<select class="form-select select-output" name="output">
						{{#outputs}}
						<option value="{{label}}">{{label}}</option>
						{{/outputs}}
					</select>
				</div>
				{{/hideOutputs}}
				{{^hideExecuteButton}}
				<div class="d-inline-flex align-items-end">
					<button class="btn btn-outline-success execute">
						<i class="fa fa-play"></i>
					</button>
				</div>
				{{/hideExecuteButton}}
			</div>
		</form>
	</div>
</div>
`;
// Exports
export default code;